import { UserAccountType } from "@spz/shared-domain";
import type { InviteUserFormValues } from "../schemas/invite-user-form.schema";

export const INVITE_USER_FORM_DEFAULT_VALUES: InviteUserFormValues = {
  email: "",
  firstName: "",
  lastName: "",
  accountType: UserAccountType.BASIC_USER,
};
